module.exports = __webpack_public_path__ + "static/media/seatosky.d15524c3.jpeg";